<form [formGroup]="form" (ngSubmit)="submitForm()">
  <title mat-dialog-title>{{ 'map.sendAlertDialog.title' | t }}</title>
  <mat-dialog-content>
    <p>{{ 'map.sendAlertDialog.description' | t }}</p>
    <sn-form [form]="form" [fields]="formFields" [model]="data"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button color="warn" type="button" (click)="cancel()">{{ 'common.cancel' | t }}</button>
    <button mat-button color="success" type="submit" [disabled]="form.invalid">{{ 'common.send' | t }}</button>
  </mat-dialog-actions>
</form>
